// extracted by mini-css-extract-plugin
export var displayNone = "_qs-6";
export var imgContainer = "_qs-2";
export var overflowHidden = "_qs-3";
export var productInfoCardButtonContainer = "_qs-5";
export var productTitleText = "_qs-4";
export var rightArrow = "_qs-1";
export var rightArrowContainer = "_qs-0";